"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_client_1 = require("./base_client");
var reverb_cookie_1 = require("../components/reverb_cookie");
var user_store_1 = require("../reverb-js-common/user_store");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var elog_1 = require("@reverbdotcom/commons/dist/elog");
var CoreClient = /** @class */ (function (_super) {
    tslib_1.__extends(CoreClient, _super);
    function CoreClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreClient.prototype.beforeRequest = function () {
        var token = reverb_cookie_1.default.get('reverb_user_oauth_token');
        if (token) {
            this.defaultHeaders.Authorization = "Bearer " + token;
        }
        Object.assign(this.defaultHeaders, lodash_1.pickBy({
            'X-Item-Region': reverb_cookie_1.default.get('itemRegionOverride'),
            'X-Display-Currency': user_store_1.default.getState().currency,
            'X-Shipping-Region': user_store_1.default.getState().shippingRegionCode,
            'Accept-Language': I18n.locale,
            'X-Context-Id': user_store_1.default.getState().cookieId,
            'X-Session-Id': elog_1.currentSession().ID(),
            'X-Reverb-App': 'REVERB',
        }, lodash_1.identity));
    };
    return CoreClient;
}(base_client_1.default));
var client = new CoreClient();
client.setDefaultHeaders({
    'Content-Type': 'application/json',
    'Accept-Version': '3.0',
});
exports.default = client;
var V4CoreClient = new CoreClient();
exports.V4CoreClient = V4CoreClient;
V4CoreClient.setDefaultHeaders({
    'Content-Type': 'application/json',
    'Accept-Version': '4.0',
});
//# sourceMappingURL=core_client.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/core_client.js
// module id = Hw3c
// module chunks = 20 21 22